import type { UppyFile } from './UppyFile'

export function assertUppyMetadata(file: UppyFile): void {
  if (!file.meta.uploaderId) {
    throw new Error('Missing metadata in file')
  }
}
